// extracted by mini-css-extract-plugin
export var button = "_8r-0";
export var icon = "_8r-1";